import { pick } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, commitMutation } from 'react-relay';
import { Checkbox, Dropdown, Label } from 'semantic-ui-react';
import styles from '../Event.scss';
import { GlobalNotifications, Intent } from '../../Modules';

export default class BookingStatus extends React.Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      user_event: { ...this.props.event.user_event }
    };
    this.getBookingStatusLabel = this.getBookingStatusLabel.bind(this);
    this.getBookingStatusIndicator = this.getBookingStatusIndicator.bind(this);
    this.changeEventStatus = this.changeEventStatus.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
    this.updateUserEvent = this.updateUserEvent.bind(this);
  }

  getBookingStatusLabel(status) {
    switch (status) {
      case 'BOOKED':
        return 'Booked';
      case 'INITIAL':
        return 'Not Booked';
      case 'CANCELED':
        return 'Canceled';
      default:
        return null;
    }
  }

  getBookingStatusIndicator(status) {
    switch (status) {
      case 'BOOKED':
        return styles.bookedIndicator;
      case 'INITIAL':
        return styles.notBookedIndicator;
      case 'CANCELED':
        return styles.canceledIndicator;
      default:
        return null;
    }
  }

  // eslint-disable-next-line camelcase
  changeEventStatus(booking_status) {
    this.setState(
      { user_event: { ...this.state.user_event, booking_status } },
      this.updateUserEvent
    );
  }

  toggleVisibility() {
    const visibility =
      this.state.user_event.visibility === 'SHOW' ? 'HIDDEN' : 'SHOW';
    this.setState(
      { user_event: { ...this.state.user_event, visibility } },
      this.updateUserEvent
    );
  }

  updateUserEvent() {
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to update event information',
        intent: Intent.DANGER
      });
    };
    const onCompleted = () => {
      GlobalNotifications.show({
        message: 'Successfully updated event information',
        intent: Intent.SUCCESS
      });
    };

    const mutation = graphql`
      mutation BookingStatus_UpdateUserEventMutation(
        $input: UpdateUserEventInput!
      ) {
        updateUserEvent(input: $input) {
          user_event {
            booking_status
            visibility
          }
        }
      }
    `;
    // eslint-disable-next-line camelcase
    const user_event = pick(this.state.user_event, [
      'id',
      'booking_status',
      'visibility'
    ]);
    const optimisticResponse = {
      updateUserEvent: { user_event: this.state.user_event }
    };
    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: {
          // eslint-disable-next-line camelcase
          ...user_event
        }
      },
      optimisticResponse,
      onCompleted,
      onError
    });
  }

  render() {
    const { event } = this.props;
    return (
      <span>
        {event.user_event &&
          <Dropdown
            basic
            floating
            className={styles.statusLabel}
            trigger={
              <span>
                <div
                  className={
                    this.getBookingStatusIndicator(event.user_event.booking_status)}
                />
                <span style={{ marginLeft: '0.5em' }}>
                  {this.getBookingStatusLabel(event.user_event.booking_status)}
                  {event.user_event &&
                    event.user_event.visibility === 'HIDDEN' &&
                    <Label
                      size='small'
                      style={{ marginLeft: '1em' }}
                      content='(Archived)'
                    />}
                </span>
              </span>
            }
          >
            <Dropdown.Menu>
              <Dropdown.Item
                value='BOOKED'
                selected={event.user_event.booking_status === 'BOOKED'}
                onClick={this.changeEventStatus.bind(null, 'BOOKED')}
              >
                <Checkbox
                  radio
                  label='Booked'
                  checked={event.user_event.booking_status === 'BOOKED'}
                />
              </Dropdown.Item>
              <Dropdown.Item
                value='INITIAL'
                selected={event.user_event.booking_status === 'INITIAL'}
                onClick={this.changeEventStatus.bind(null, 'INITIAL')}
              >
                <Checkbox
                  radio
                  label='Not Booked'
                  checked={event.user_event.booking_status === 'INITIAL'}
                />
              </Dropdown.Item>
              <Dropdown.Item
                value='BOOKED'
                selected={event.user_event.booking_status === 'CANCELED'}
                onClick={this.changeEventStatus.bind(null, 'CANCELED')}
              >
                <Checkbox
                  radio
                  label='Canceled'
                  checked={event.user_event.booking_status === 'CANCELED'}
                />
              </Dropdown.Item>
              <Dropdown.Divider />
              <Dropdown.Item onClick={this.toggleVisibility}>
                <Checkbox
                  label='Archived'
                  checked={event.user_event.visibility === 'HIDDEN'}
                />
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/BookingStatus.js